import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../../utils/typeboxHelpers';

export const zxyObjectTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    /** The name of the object */
    name: Type.String({ maxLength: 255 }),
    /** The code of the object */
    code: makeNullable(Type.String({ maxLength: 255 })),
    /** Description of the location */
    location: makeNullable(Type.String({ maxLength: 255 })),
    latitude: makeNullable(Type.Number()),
    longitude: makeNullable(Type.Number()),
    updatedOn: Type.String(),
    /** Not in use */
    compositionIsVisible: Type.Boolean(),
    /** Determines user access rights. The client that added the object. Can be the owner or the surveyor. */
    clientCompanyId: Type.String({ format: 'uuid' }),
    /** Determines user access rights. The operator is for example the drone company that does not do the survey. */
    operatorCompanyId: makeNullable(Type.String({ format: 'uuid' })),
    /** Determines user access rights. The surveyor company. */
    surveyorCompanyId: makeNullable(Type.String({ format: 'uuid' })),
    /** The type of object */
    objectTypeId: Type.String({ format: 'uuid' }),
    created_at: makeNullable(Type.String()),
    updated_at: makeNullable(Type.String()),
    /** The inspection standard used. This determines the decomposition of the object */
    inspectionStandardId: Type.String({ format: 'uuid' }),
    /** Determines user access rights. The asset owner */
    ownerCompanyId: makeNullable(Type.String({ format: 'uuid' })),
    customerVersion: makeNullable(Type.String({ maxLength: 255 })),
    /** Object visible for demo account. Not in use. */
    isPublic: makeNullable(Type.Boolean()),
    /** Object belonging to a site or plant. Not in use. */
    siteId: makeNullable(Type.String({ format: 'uuid' })),
    constructionYear: makeNullable(Type.Integer()),
    /** External id used in other system */
    externalRefId: makeNullable(Type.String({ maxLength: 255 })),
    usage: makeNullable(Type.String({ maxLength: 255 })),
    managementOrganization: makeNullable(Type.String({ maxLength: 255 })),
    /** Shape of the object on the map. Can be a line or a polygon. */
    shape: makeNullable(Type.Any()),
    /** Spatial reference shape. E.g. WGS84=3857. Dutch-RD=28992 */
    shapeSrid: makeNullable(Type.Integer()),
    status: makeNullable(Type.String({ maxLength: 255 })),
    effortCategory: makeNullable(Type.String({ maxLength: 255 })),
    effortCalculation: makeNullable(Type.Integer()),
    trafficType: makeNullable(Type.String({ maxLength: 255 })),
    mainMaterial: makeNullable(Type.String({ maxLength: 255 })),
    marineInfrastrutureType: makeNullable(Type.String({ maxLength: 255 })),
    length: makeNullable(Type.Number()),
    width: makeNullable(Type.Number()),
    squareMeters: makeNullable(Type.Number()),
    /** Additional properties of an object stored in json format */
    attributes: Type.Any(),
    /** Unclear if still in ue */
    inspectionStandardData: Type.Any(),
    /** Object can be part of a complex. Name of that complex. */
    complexName: makeNullable(Type.String({ maxLength: 255 })),
    /** Object can be part of a complex. Code of that complex. */
    complexCode: makeNullable(Type.String({ maxLength: 255 })),
    /** Object can be part of a complex. Location of that complex. */
    complexLocation: makeNullable(Type.String({ maxLength: 255 })),
    municipality: makeNullable(Type.String({ maxLength: 255 })),
    province: makeNullable(Type.String({ maxLength: 255 })),
    /** Permissions for ZXY Exchange */
    zxyExchangeAccessType: makeNullable(Type.String()),
    /** Register for availability in ZXY Exchange */
    zxyExchangeAccessRegistrationId: makeNullable(Type.String({ maxLength: 255 })),
    /** Labels added to object */
    labels: Type.Any(),
    /** Fields can be defined for an object type. The values for those fields for an object are here in json format. */
    objectTypeFieldsValues: Type.Any(),
    /** Generated for better perfomance on map */
    locationPoint: makeNullable(Type.Any()),
    /** ID or code to identify the job or import action to which a group of objects was added */
    importId: makeNullable(Type.String({ maxLength: 255 })),
    /** General remarks for the object */
    remarks: makeNullable(Type.String()),
});

/** Asset such as a bridge or oil tank for which surveys are carried out */
export type ZxyObject = Static<typeof zxyObjectTableSchema>;
